import { ApolloLink, Observable } from '@apollo/client';
import { parseQueryParams } from './RestLink/parseQueryParams';
var OperationType;
(function(OperationType) {
    OperationType["QUERY"] = "query";
    OperationType["MUTATION"] = "mutation";
})(OperationType || (OperationType = {}));
const parseQueryString = (query)=>{
    const queryString = query.includes('?') ? query.slice(query.indexOf('?')) : undefined;
    if (!queryString) return {};
    const queryParams = parseQueryParams(queryString);
    const parsedParams = {};
    Object.entries(queryParams).forEach(([key, value])=>{
        parsedParams[key] = Array.isArray(value) ? value.join(',') : value;
    });
    return parsedParams;
};
const extractPayloadAndResponse = (internalOperation, result)=>{
    var _internalOperation_query_definitions_find, _internalOperation_query_loc, _internalOperation_getContext;
    const definition = (_internalOperation_query_definitions_find = internalOperation.query.definitions.find((def)=>def.kind === 'OperationDefinition')) === null || _internalOperation_query_definitions_find === void 0 ? void 0 : _internalOperation_query_definitions_find.operation;
    const operationType = definition === "query" ? 'QUERY' : 'MUTATION';
    const payload = ((_internalOperation_query_loc = internalOperation.query.loc) === null || _internalOperation_query_loc === void 0 ? void 0 : _internalOperation_query_loc.source.body) || '';
    const variables = internalOperation.variables;
    const requestFromContext = (_internalOperation_getContext = internalOperation.getContext()) === null || _internalOperation_getContext === void 0 ? void 0 : _internalOperation_getContext.underlyingRequest;
    const underlyingRequest = requestFromContext && operationType === 'MUTATION' ? {
        method: requestFromContext['@rest'].method,
        endpoint_url: requestFromContext['@rest'].runtimePath,
        body: JSON.stringify(variables.bodyBuilder(requestFromContext)),
        query_params: parseQueryString(variables.pathBuilder(requestFromContext))
    } : undefined;
    const requestPayload = {
        operation_type: operationType,
        operation_name: internalOperation.operationName,
        operation_payload: payload,
        request_variables_json: JSON.stringify(variables),
        response_payload: JSON.stringify(result)
    };
    const mutationPayload = underlyingRequest ? {
        underlying_request_json: JSON.stringify(underlyingRequest)
    } : undefined;
    return {
        requestPayload,
        mutationPayload
    };
};
export default function createComparisonV1ToV2Link(shadowComparisonOperationsV1ToV2) {
    return new ApolloLink((operation, forward)=>{
        const context = operation.getContext();
        var _context_fetch;
        const fetch = (_context_fetch = context.fetch) !== null && _context_fetch !== void 0 ? _context_fetch : window.fetch;
        return new Observable(function comparisonV2ToV2Observer(observer) {
            const subscription = forward(operation).subscribe({
                next: function onNextComparisonV1ToV2Link(data) {
                    if (shadowComparisonOperationsV1ToV2 === null || shadowComparisonOperationsV1ToV2 === void 0 ? void 0 : shadowComparisonOperationsV1ToV2[operation.operationName]) {
                        const comparisonPayload = extractPayloadAndResponse(operation, data);
                        const body = new URLSearchParams(comparisonPayload.requestPayload);
                        if (comparisonPayload.mutationPayload) {
                            body.append('underlying_request_json', comparisonPayload.mutationPayload.underlying_request_json);
                        }
                        fetch('/v1/graphql_gateway/compare_operation', {
                            method: 'POST',
                            body,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        });
                    }
                    return observer.next(data);
                },
                error: function onErrorComparisonV1ToV2Link(error) {
                    return observer.error(error);
                },
                complete: function onCompleteComparisonV1ToV2Link() {
                    return observer.complete();
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        });
    });
}

//# sourceMappingURL=createComparisonV1ToV2Link.js.map